import { createContext, useContext } from "react";

export interface EmbeddedWalletSession {
  addresses: string[];
  showAuthFlow: () => void;
  disconnect: () => Promise<void>;
}

export const defaultEmbeddedWalletSession: EmbeddedWalletSession = {
  addresses: [],
  showAuthFlow: () => {},
  disconnect: async () => {},
};

export const EmbeddedWalletSessionContext = createContext<EmbeddedWalletSession>(defaultEmbeddedWalletSession);

export const useEmbeddedWalletSession = (): EmbeddedWalletSession => useContext(EmbeddedWalletSessionContext);
